import React from 'react';
import PropTypes from 'prop-types';

import { Container, Form, Button, Message} from 'semantic-ui-react';

const ChangePassword = props => {
    let errorMessage;
    if (props.error) {
        const content = Array.isArray(props.error) ? props.error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : props.error;
        errorMessage = (<Message error header="Password Reset Failed" content={content} />);
    }
    const {password, confirmPassword, oldPassword} = props.data;
    const passwordsMatch = password && confirmPassword && password === confirmPassword;
    return (
        <Container>
            <Form onSubmit={props.onSubmit} loading={props.loading} error>
                <Form.Field>
                    <input name="oldPassword" type="password" placeholder="Current Password" onChange={props.onChange} value={oldPassword || ''} />
                </Form.Field>
                <Form.Field>
                    <input name="password" type="password" placeholder="New Password" onChange={props.onChange} value={password || ''} />
                </Form.Field>
                <Form.Field>
                    <input name="confirmPassword" type="password" placeholder="Confirm New Password" onChange={props.onChange} value={confirmPassword || ''} />
                </Form.Field>
                {errorMessage}
                <Form.Field>
                <Button primary type="submit" disabled={!passwordsMatch}>Change Password</Button>
                    
                </Form.Field>
                <Form.Field>
                New Password Requirements:
                    <ul>
                        <li>Must be at least 8 characters</li>
                        <li>Must contain at least one digit</li>
                        <li>Must contain at least one uppercase and one lowercase character</li>
                    </ul>
                </Form.Field>
            </Form>
        </Container>
    );
};

ChangePassword.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.object.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default ChangePassword;